export default __webpack_public_path__ + "static/media/interpreting_carousel_3.73bce17b.jpg";